var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadLinear = function SvgUploadLinear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 16.25h12.5V13h1.5v4.75H2.25V13h1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.81 5.75h-4.06v6.75h-1.5V5.75H5.19L10 .94zm-6-1.5h2.38L10 3.06z",
    clipRule: "evenodd"
  })));
};
export { SvgUploadLinear as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zLjc1IDE2LjI1SDE2LjI1VjEzSDE3Ljc1VjE3Ljc1SDIuMjVWMTNIMy43NVYxNi4yNVoiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC44MTA1IDUuNzVIMTAuNzVWMTIuNUg5LjI1VjUuNzVINS4xODk0NUwxMCAwLjkzOTQ1M0wxNC44MTA1IDUuNzVaTTguODEwNTUgNC4yNUgxMS4xODk1TDEwIDMuMDYwNTVMOC44MTA1NSA0LjI1WiIgLz4KPC9zdmc+Cg==";